import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})

export class FiltersService<T> {
  private currentFilters: T;
  private lastContext: string;
  constructor() {
  }

  setCurrentFilters(currentFilters: T, currentContext: string): void {
    this.currentFilters = currentFilters;
    this.lastContext = currentContext;
  }
  getCurrentFilters(currentContext: string): T {
    if (this.lastContext === currentContext) {
      return this.currentFilters;
    } else {
      this.lastContext = "";
    }
  }
}
